<section [innerHtml]="schemaData | safeHtml"></section>
